import React from 'react';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import HomeIcon from '@mui/icons-material/Home';
import './property.scss';
import PropTypes from 'prop-types';

function PropertyConfirmation({ systemId, propertyData = {} }) {
  const navigate = useNavigate();
  const handleGoToDashboard = () => {
    navigate('/property-list');
  };

  const handleShareProperty = () => {
    // TODO: Implement share functionality
    alert('Share functionality will be implemented soon!');
  };

  const copyId = () => {
    const idToCopy = systemId || 'No ID';
    navigator.clipboard.writeText(idToCopy);
    alert('Property ID copied to clipboard!');
  };

  return (
    <div className="confirmation-card">
      {/* Success Icon + Title */}
      <div className="confirmation-header">
        <CheckCircleIcon className="success-icon" />
        <h2>Property Submitted Successfully!</h2>
        <p>Your property has been successfully added to the platform and is ready for listing.</p>
      </div>        {/* Property ID */}
      <div className="property-id-box">
        <span className="property-id">{systemId || 'Not Available'}</span>
        <button className="btn-copy" onClick={copyId} style={{ fontSize: '12px', padding: '4px 8px' }}>
          <ContentCopyIcon fontSize="small" /> Copy ID
        </button>
        <p className="note">Save this ID for future reference. You can use it to track and manage your property listing.</p>
      </div>        {/* Property Summary */}
      <div className="property-summary" style={{
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '24px',
        backgroundColor: '#fafafa',
      }}>
        <h4 style={{
          display: 'flex',
          alignItems: 'center',
          fontSize: '16px',
          fontWeight: 600,
          marginBottom: 16,
          color: '#333',
        }}>
          <HomeIcon style={{ marginRight: 8, fontSize: 20, verticalAlign: 'middle' }} />
          Property Information
        </h4>
        <div className="summary-grid">
          <div>
            <label>Property Type</label>
            <p>{propertyData.property_type && propertyData.property_sub_type ? `${propertyData.property_type} - ${propertyData.property_sub_type}` : 'Not specified'}</p>
          </div>
          <div>
            <label>Purchase Date</label>
            <p>{propertyData.purchase_date || 'Not specified'}</p>
          </div>
          <div>
            <label>Purchase Price</label>
            <p>{propertyData.purchase_price ? `₹ ${Number(propertyData.purchase_price).toLocaleString('en-IN')}` : 'Not specified'}</p>
          </div>
          <div>
            <label>Estimated Current Value</label>
            <p>{propertyData.estimated_current_value ? `₹ ${Number(propertyData.estimated_current_value).toLocaleString('en-IN')}` : 'Not specified'}</p>
          </div>
          <div>
            <label>Location</label>
            <p>{[propertyData.city, propertyData.state, propertyData.country].filter(Boolean).join(', ') || 'Not specified'}</p>
          </div>
          <div>
            <label>Owner Contact</label>
            <p>{propertyData.owner_name || 'Not specified'}</p>
          </div>
          <div>
            <label>Land Extent</label>
            <p>{propertyData.land_extent ? `${propertyData.land_extent} ${propertyData.unit || ''}` : 'Not specified'}</p>
          </div>
          <div>
            <label>Status</label>
            <p>{propertyData.status || 'Draft'}</p>
          </div>
        </div>
      </div>

      {/* Next Steps */}
      <div className="whats-next">
        <h4>What&apos;s Next?</h4>
        <ol>
          <li><strong>Property Review:</strong> Your property is now listed and visible to potential buyers. You can manage it from your dashboard.</li>
          <li><strong>Manage Your Listing:</strong> Update property details, photos, or pricing anytime from the My Properties dashboard.</li>
          <li><strong>Track Performance:</strong> Monitor inquiries, views, and interest in your property through the dashboard analytics.</li>
        </ol>
      </div>

      {/* Action Buttons */}
      <div className="confirmation-actions">
        <button className="btn primary" onClick={handleGoToDashboard}>Go to My Properties Dashboard</button>
        <button className="btn secondary" onClick={handleShareProperty}>Share Property</button>
      </div>

      {/* Footer */}
      <p className="footer-note">🎉 Congratulations! Your property is now part of the Indian real estate marketplace.</p>
    </div>
  );
}
PropertyConfirmation.propTypes = {
  propertyData: PropTypes.object,
  systemId: PropTypes.string,
};

export default PropertyConfirmation;
